.map {
  height: 60dvh;
}

.campsContainer {
  display: grid;
  gap: var(--space-lg);
  grid-template-columns: repeat(auto-fit, minmax(var(--min-card-size), 1fr));
  grid-auto-flow: dense;
  transition: all 0.3s;
}

.placeholder {
  /* biome-ignore lint/complexity/noImportantStyles: TODO */
  background: var(--bs-primary-bg-subtle) !important;
  opacity: 0.5;
  display: grid;
  grid-template-rows: subgrid;
  grid-row: span 3;

  button {
    position: absolute;
    inset: 0;
    color: var(--bs-primary);
    font-size: 1.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-sm);
  }

  &:first-child {
    display: none;
  }

  &:hover {
    opacity: 1;
  }
}
